<template lang="pug">
v-container
    v-layout(row wrap)
        v-flex(xs12)
            v-card.transparent(dark flat)
                v-card-text.text-center
                    h2.pt-10.display-2.white--text SUBSIDIOS
                    h3.font-weight-regular PRENATAL - NATALIDAD - LACTANCIA - DEFUNCION
                v-card-text.no-padding.mt-5
                    v-layout(row wrap)
                        v-flex(xs12 md6)
                            h3.display-1.font-weight-light.white--text.pb-1 Información:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding
                                p.subtitle-1(style="line-height:22px;text-align:justify;").no-margin.pt-4 <strong style="color:#2C6 !important;">SUBSIDIO PRENATAL.-</strong> Es el pago en especie a la madre gestante asegurada o beneficiaria, por el valor de un salario mínimo nacional. La duración del subsidio prenatal comienza a partir del primer dia del quinto mes de embarazo y fenece al nacimiento de la(s) niñas o niño(s).
                                p.subtitle-1(style="line-height:22px;text-align:justify;").no-margin.pt-4 <strong style="color:#2C6 !important;">SUBSIDIO DE NATALIDAD.-</strong> Consiste en la otorgación a los beneficiarios de una cancelación única de dinero, equivalente a un salario minimo nacional por el nacimiento de cada hijo
                                p.subtitle-1(style="line-height:22px;text-align:justify;").no-margin.pt-4 <strong style="color:#2C6 !important;">SUBSIDIO DE LACTANCIA.-</strong> Es el pago en especie, equivalente a un salario minimo nacional por cada hijo(a) durante sus primeros doce meses de vida.
                            h3.display-1.font-weight-light.white--text.pb-1.pt-3 Requisitos:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding.mt-4
                                p.subtitle-1.white--text.font-weight-bold(style="line-height:22px;color:#2C6 !important;").no-margin SUBSIDIO PRENATAL
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 1er. juego (Departamental)
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario de solicitud de subsidios (Formulario web encontrado en la actual página).<br>
                                    | - <strong>Certificado de atención prenatal expedido por la CNS,</strong> con el correspondiente sello de vigencia de derechos (fotocopia)<br>
                                    | - C.I. del asegurado y de la beneficiaria (fotocopias).<br>
                                    | - Boleta de pago del último mes (fotocopia).
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 2do. juego (Ministerio de Educación)
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Certificado de atención prenatal expedido por la CNS, firmado por el médico tratante y con el correspondiente sello de vigencia de derechos (fotocopia).<br>
                                    | - C.I. del asegurado y de la beneficiaria (fotocopias).<br>
                                    | - Boleta de pago del último mes (fotocopia).
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 3er. juego (Dirección Distrital)
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario de solicitud de subsidios (fotocopia)<br>
                                    | - <strong>Certificado de atención prenatal expedido por la CNS,</strong> con el correspondiente sello de vigencia de derechos (fotocopia)<br>
                                    | - C.I. del asegurado y de la beneficiaria (fotocopias).<br>
                                    | - Boleta de pago del último mes (fotocopia).<br>
                                    | - Avc 04 del asegurado y de la beneficiaria (fotocopia).
                                p.subtitle-1.white--text.font-weight-bold(style="line-height:22px;color:#2C6 !important;").no-margin SUBSIDIO DE NATALIDAD Y SUBSIDIO DE LACTANCIA
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 1er. juego (Departamental)
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario de solicitud de subsidios (Formulario web encontrado en la actual página).<br>
                                    | - Certificado de nacimiento del niño(a) con sello seco de registro civil.<br>
                                    | - AVC-06 del niño(a) expedido por la CNS copia para la Empresa (fotocopia).<br>
                                    | - C.I. del asegurado y de la beneficiaria (fotocopia).<br>
                                    | - Boleta de pago del último mes (fotocopia).<br>
                                    | - Certificado de matrimonio o acta de reconocimiento (una fotocopia).
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 2do. juego (Ministerio de Educación)
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - AVC-06 del niño(a) expedido por la CNS copia para la EMpresa (original)<br>
                                    | - Certificado de nacimiento del niño(a) (fotocopia).<br>
                                    | - C.I. del asegurado y de la beneficiaria (fotocopia).<br>
                                    | - Certificado de matrimonio o acta de reconocimiento (una fotocopia).
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 3er. juego (Dirección Distrital)
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario de solicitud de subsidios (fotocopia)<br>
                                    | - Certificado de nacimiento del niño(a) con sello seco de registro civil(fotocopia).<br>
                                    | - AVC-06 del niño(a) expedido por la CNS copia para la Empresa y (fotocopia).<br>
                                    | - C.I. del asegurado y de la beneficiara (fotocopias)<br>
                                    | - Boleta de pago del último mes (fotocopia).<br>
                                    | - AVC-04 o AVC-06 del asegurado y de la beneficiaria (fotocopia).<br>
                                    | - Certificado de nacido vivo del niño(a) recién nacido (una fotocopia).<br>
                                    | - Certificado de vacunas del niño(a) recién nacido (una fotocopia).<br>
                                    | - Certificado de matrimonio o acta de reconocimiento (fotocopia)<br>
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin * <strong>NOTA:</strong> Los tres juegos deben estar debidamente engrampados de acuerdo al orden establecido arriba.
                        v-flex(xs12 md5 offset-md-1)
                            h3.display-1.font-weight-light.white--text.text-center Solicitud de Subsidios:
                            c-form-solicitud-subsidios
            v-dialog(v-model="dialogConfirm" width=400)
                v-card
                    v-toolbar(dark color="success" dense).no-padding.no-margin
                        v-toolbar-title Archivo subido.
                        v-spacer
                        v-btn(icon dark @click="dialogConfirm = false")
                            v-icon fas fa-times
                    v-card-text.text-center.pb-5
                        h3.pt-3 Su archivo fué subido correctamente al servidor, puede verificarlo mas adelante con su ci:
                        h3.pt-2 4687156
                        v-btn(color="success" @click="dialogConfirm = false").mt-2 Aceptar
            v-dialog(v-model="dialogUltimosDec" width=600 scrollable)
                v-card
                    v-toolbar(dar color="success" dense dark).no-padding.no-margin
                        v-toolbar-title Últimos archivos (.dec) subidos por: 4434655
                        v-spacer
                        v-btn(icon dark @click="dialogUltimosDec = false")
                            v-icon fas fa-times
                    v-card-text.no-padding(style="height:305px")
                        v-data-table(:headers="headers" :items="desserts" disable-pagination hide-default-footer)
                            template(v-slot:item.estado="{ item }")
                                v-chip(color="green" dark) {{ item.estado }}
                                    v-icon(right small) fas fa-check
</template>
<script>
export default {
    data() {
        return {
            dialogConfirm: false,
            dialogUltimosDec: false,
            isLoading: false,
            headers: [
                { text: 'CI:', align: 'center', value: 'ci' },
                { text: 'Periodo (MES):', align: 'center',value: 'mes' },
                { text: 'Periodo (AÑO)', align: 'center',value: 'gestion' },
                { text: 'Fecha de presentación', align: 'center',value: 'fechaPresentacion' },
                { text: 'Estado', align: 'center',value: 'estado' }
            ],
            desserts: [
                {
                    ci: '4434655',
                    fechaPresentacion: '22/01/2019',
                    mes: 'enero',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '20/02/2019',
                    mes: 'febrero',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '19/03/2019',
                    mes: 'marzo',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '22/04/2019',
                    mes: 'abril',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '19/05/2019',
                    mes: 'mayo',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '02/06/2019',
                    mes: 'enero',
                    gestion: 2019,
                    estado: 'Presentado'
                }
            ]
        }
    },
    methods: {
        subirArchivoDec(){
            //this.isLoading = true
            this.dialogConfirm = true
            this.$snotify.success('Archivo subido correctamente.',{timeout:15000})
        }
    }
}
</script>